import { Box, Flex } from '@chakra-ui/react';
import { Text } from '@diamond/shared/ui';

export interface OrderStatusBadgeProps {
  label: string;
  color: string;
  bg: string;
  dotColor?: string;
}

/**
 * Badge component for displaying SO (Sales Order) status on collapsed row
 * Uses SO_STATUS_CONFIG for colors and labels
 * Examples: "Menunggu Konfirmasi", "Diproses", "Dikirim", "Selesai"
 */
export function OrderStatusBadge({
  label,
  color,
  bg,
  dotColor,
}: OrderStatusBadgeProps) {
  return (
    <Flex
      align="center"
      gap={1}
      p="8.5px"
      borderRadius="4px"
      bg={bg}
      flexShrink={0}
      data-testid="order-status-badge"
    >
      <Box
        w="6px"
        h="6px"
        borderRadius="full"
        bg={dotColor || color}
        data-testid="status-dot"
      />
      <Text
        fontFamily="Libre Franklin"
        fontSize="12px"
        fontWeight="400"
        lineHeight="100%"
        letterSpacing="0%"
        color={color}
      >
        {label}
      </Text>
    </Flex>
  );
}
